<template>
  <div class="cards-area">
    <div>
      <button class="btn btn-outline-primary" @click="addCard" >Add Card</button>
    </div>
    <div v-if="apiLoading" class="d-flex align-items-center justify-content-center">
      <b-spinner :variant="'info'"
                 style="width: 3rem; height: 3rem;"
                 label="Large Spinner">
      </b-spinner>
    </div>
    <div class="row">
      <div class="col-xl-6 col-lg-9" v-for="card in cards">
        <card @deleted="getCards()" :card="card"></card>
      </div>
    </div>
    <AddCard @created="getCards()"/>
  </div>
</template>

<script>
import card from './Card'
import AddCard from "./AddCard";
import ApiMixin from '@core/mixin/ApiMixin'

export default {
  name: "Index",
  components: {AddCard, card},
  mixins: [ApiMixin],
  data() {
    return {
      cards: []
    }
  },
  methods: {
    addCard() {
      this.$bvModal.show('create-credit-card')
    },
    getCards() {
      this.get('customer_cards').then((res) => {
        this.cards = res
      })
    }
  },
  mounted() {
    this.getCards()
  }
}
</script>

<style scoped>
  .cards-area {
    margin: 0px 20px;
  }
</style>
